import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const AccessDenied = ({
    containerClassName = '',
    message = 'You need active Premier Access to access this feature.',
    helpText = 'Contact your administrator if you believe you should have access to this feature.',
}) => (
    <Container className={containerClassName}>
        <Row>
            <Col className="text-center">
                <div className="access-denied">
                    <h1>Access Denied</h1>
                    <p>{message}</p>
                    <div className="access-denied-help">
                        <small className="text-muted">
                            {helpText}
                        </small>
                    </div>
                </div>
            </Col>
        </Row>
    </Container>
);

AccessDenied.propTypes = {
    containerClassName: PropTypes.string,
    message: PropTypes.string,
    helpText: PropTypes.string,
};

export default AccessDenied;

